module.exports = __webpack_public_path__ + "img/game-over.c0b3690f.png";